import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ClickableIcon',
  props: {
    icon: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    onlyVisual: {
      type: Boolean,
      default: false
    },
    badgeNumber: {
      type: Number,
      default: 0
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'ClickableIcon'
    });
    return {
      __sfc: true,
      SIcon: SIcon
    };
  }
});